import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';

@Component({ selector: 'spline-chart', templateUrl: './spline-chart.component.html', styleUrls: ['./spline-chart.component.scss'], encapsulation: ViewEncapsulation.None })
export class SplineChartComponent implements OnInit {
    @Input('graphData') graphData: any;
    graphType = "";
    eventsData = [];
    barData = [];
    graphSeries = [];
    graphMonth = [];
    graphWeekDays = [];
    graphDays = [];
    graphYears = [];
    graphCustom = [];
    xAxis = {};
    y1AxisAvaialble = 0;
    y2AxisAvaialble = 0;
    week = [];
    hour: string[] = ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'];
    weekDays: string[] = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    month: string[] = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    dateInMonth: string[] = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'];

    options: Object;
    constructor() { }

    getRandomRgb() {
        var letters = 'BCDEF'.split('');
        var color = '#';
        for (var i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * letters.length)];
        }

        let hex = color.replace('#', '');
        let r = parseInt(hex.substring(0, 2), 16);
        let g = parseInt(hex.substring(2, 4), 16);
        let b = parseInt(hex.substring(4, 6), 16);

        return 'rgba(' + r + ', ' + g + ', ' + b + ',0.4)';
    }

    ngOnInit() {
        let dataLabels = {};
        let chartLabelSettings = (this.graphData.udf.numericConfig && this.graphData.udf.numericConfig.chartLabelSettings) ? this.graphData.udf.numericConfig.chartLabelSettings : false;
        if (chartLabelSettings) {
            let chartLabelDecimals = this.graphData.udf.numericConfig.chartLabelDecimals;
            dataLabels = {
                enabled: true,
                rotation: this.graphData.udf.numericConfig.chartLabelAlignment,
                x: 2,
                y: -15,
                color: this.graphData.udf.numericConfig.chartLabelColor,
                format: '{point.y:,.' + chartLabelDecimals + 'f}',
                // formatter:JSON.stringify(function() {
                //     if(this.y != 0) {
                //         return this.y.toFixed(chartLabelDecimals);
                //     }
                // }),
                style: {
                    fontWeight: 'bold',
                    fontSize: this.graphData.udf.numericConfig.chartLabelFontSize
                }
            };
        }
        this.y1AxisAvaialble = 0;
        this.y2AxisAvaialble = 0;
        this.graphType = this.graphData.fetchDataFor;

        this
            .graphData
            .events
            .forEach((v, i) => {
                let tempArr = {
                    color: this.getRandomRgb(), // Color value
                    from: new Date(Date.parse(v.from)), // Start of the plot band
                    to: new Date(Date.parse(v.to)),
                    label: {
                        style: {
                            color: '#8e8e8e'
                        },
                        align: 'left',
                        useHTML: true,
                        verticleAlign: 'top',
                        text: '&nbsp;' + v.eventName
                    }
                };
                this
                    .eventsData
                    .push(tempArr);
            });
        this
            .graphData
            .dataFilter
            .forEach((v, i) => {
                this.graphSeries = [];
                let decimals = 0;
                // let yAxis = (v.data.length > 0) ? v.data[0].value : 0; let tempArr = {
                // name: v.label,   data: [yAxis],   color: v.color }
                if (v.data.length > 0) {
                    this.graphWeekDays = [];
                    // this.graphMonth = []; this.graphWeekDays = []; this.graphDays = [];
                    // this.graphYears = []; this.graphCustom = [];
                    v
                        .data
                        .forEach((data, index) => {
                            let tempSeries = [];

                            if (this.graphData.udf.consolidateData || this.graphData.timeFrame == "dayOfWeek"  || this.graphData.timeFrame == "week") {
                                if (this.graphData.timeFrame == 'month') {
                                    tempSeries.push(this.month[data.date - 1]);
                                    this.graphMonth.push(this.month[data.date - 1]);
                                }
                                if (this.graphData.timeFrame == 'dayOfWeek') {
                                    if (!this.graphData.udf.consolidateData) {
                                        let w = data.date.split("|");
                                        tempSeries.push(this.weekDays[w[0] - 1] + " " + w[1]);
                                        this.graphWeekDays.push(this.weekDays[w[0] - 1] + " " + w[1]);
                                    } else {
                                        tempSeries.push(this.weekDays[data.date - 1]);
                                        this.graphWeekDays.push(this.weekDays[data.date - 1]);
                                    }
                                }
                                if (this.graphData.timeFrame == 'dayOfMonth') {
                                    tempSeries.push(Date.parse(data.dateFrom));
                                    this.graphDays.push(Date.parse(data.dateFrom));
                                }
                                if (this.graphData.timeFrame == 'week') {
                                    tempSeries.push("week " + data.date);
                                    this.week.push("week " + data.date);
                                }
                                if (this.graphData.timeFrame == 'year') {
                                    tempSeries.push(data.date);
                                    this.graphYears.push(data.date);
                                }
                                if (this.graphData.timeFrame == 'custom') {
                                    tempSeries.push(Date.parse(data.dateFrom));
                                    this.graphCustom.push(Date.parse(data.dateFrom));
                                }
                                if (this.graphData.timeFrame == 'hour') {
                                    tempSeries.push(this.hour[data.date]);
                                }
                            } else {

                                if (this.graphData.timeFrame == 'custom') {
                                    tempSeries.push(Date.parse(data.dateFrom));
                                    this.graphCustom.push(Date.parse(data.dateFrom));
                                } else {
                                    tempSeries.push(data.date);
                                    this.graphCustom.push(data.date);
                                }
                            }

                            let graphValue = data.value;
                            decimals = 0;
                            if (this.graphData.udf.axisConfig) {
                                decimals = (v.showOnAxis == "y1"
                                    ? this.graphData.udf.axisConfig.y1.decimals
                                    : this.graphData.udf.axisConfig.y2.decimals);
                                if (decimals != 0) {
                                    graphValue = parseFloat(graphValue.toFixed(decimals));
                                } else {
                                    graphValue = Math.round(graphValue);
                                }
                            };
                            tempSeries.push(graphValue);
                            this
                                .graphSeries
                                .push(tempSeries);
                        })
                };
                //create full date series

                let tempGraphSeries = [];
                if (this.graphData.udf.consolidateData || this.graphData.timeFrame == "dayOfWeek") {
                    if (this.graphData.timeFrame == 'month') {
                        this
                            .month
                            .forEach((m, i) => {
                                let tempGraphData = [];
                                tempGraphData.push(m, 0);
                                this
                                    .graphSeries
                                    .forEach((gs, i) => {
                                        if (m == gs[0]) {
                                            tempGraphData[1] = gs[1];
                                        }
                                    });
                                tempGraphSeries.push(tempGraphData);
                            });
                    }
                    if (this.graphData.timeFrame == 'dayOfWeek') {
                        if (!this.graphData.udf.consolidateData) {
                            tempGraphSeries = this.graphSeries;
                        } else {
                            this
                                .weekDays
                                .forEach((w, i) => {
                                    let tempGraphData = [];
                                    tempGraphData.push(w, 0);
                                    this
                                        .graphSeries
                                        .forEach((gs, i) => {
                                            if (w == gs[0]) {
                                                tempGraphData[1] = gs[1];
                                            }
                                        });
                                    tempGraphSeries.push(tempGraphData);
                                });
                        }

                    }                    
                    if (this.graphData.timeFrame == 'dayOfMonth') {
                        this
                            .dateInMonth
                            .forEach((d, i) => {
                                let tempGraphData = [];
                                tempGraphData.push(d, 0);
                                this
                                    .graphSeries
                                    .forEach((gs, i) => {
                                        if (d == gs[0]) {
                                            tempGraphData[1] = gs[1];
                                        }
                                    });
                                tempGraphSeries.push(tempGraphData);
                            });
                    }
                    if (this.graphData.timeFrame == 'hour') {
                        this
                            .hour
                            .forEach((hr, i) => {
                                let tempGraphData = [];
                                tempGraphData.push(hr, 0);
                                this
                                    .graphSeries
                                    .forEach((gs, i) => {
                                        if (hr == gs[0]) {
                                            tempGraphData[1] = gs[1];
                                        }
                                    });
                                tempGraphSeries.push(tempGraphData);
                            });
                    }
                    if (this.graphData.timeFrame == 'week') {
                        tempGraphSeries = this.graphSeries;
                    }
                    if (this.graphData.timeFrame == 'year') {
                        tempGraphSeries = this.graphSeries;
                    }
                    if (this.graphData.timeFrame == 'custom') {
                        tempGraphSeries = this.graphSeries;
                    }
                } else {
                    tempGraphSeries = this.graphSeries;
                }
                // console.log(tempGraphSeries); set decimals value
                decimals = 0;
                if (this.graphData.udf.axisConfig) {
                    decimals = (v.showOnAxis == "y1"
                        ? this.graphData.udf.axisConfig.y1.decimals
                        : this.graphData.udf.axisConfig.y2.decimals);
                };
                let tempArr = {
                    name: v.label,
                    data: tempGraphSeries, //this.graphSeries,
                    color: v.color,
                    yAxis: (v.showOnAxis == "y2"
                        ? 1
                        : 0),
                    tooltip: {
                        pointFormat: v.label + ": {point.y:." + decimals + "f}<br>"
                    }
                };
                // check if y1 axis is available
                if (v.showOnAxis == "y1") {
                    this.y1AxisAvaialble += 1;
                };
                // check if y2 axis is available
                if (v.showOnAxis == "y2") {
                    this.y2AxisAvaialble += 1;
                };
                this
                    .barData
                    .push(tempArr);
            });
        // console.log(this.barData);
        let graphCategories = [];

        if (this.graphData.udf.consolidateData || this.graphData.timeFrame == "dayOfWeek" || this.graphData.timeFrame == "week") {
            switch (this.graphData.timeFrame) {
                case 'month':
                    graphCategories = this.month; //this.graphMonth;
                    break;
                case 'dayOfWeek':
                    if (!this.graphData.udf.consolidateData) {
                        graphCategories = this.graphWeekDays;
                    } else {
                        graphCategories = this.weekDays;
                    }
                    break;                
                case 'dayOfMonth':
                    graphCategories = this.dateInMonth; //this.graphDays;
                    break;
                case 'week':
                    graphCategories = this.week;
                    break;
                case 'year':
                    graphCategories = this.graphYears;
                    break;
                case 'custom':
                    graphCategories = this.graphCustom;
                    break;
                case 'hour':
                    graphCategories = this.hour;
                    break;
            }
        } else {
            graphCategories = this.graphCustom;
        }

        //get unique value from graphCategories
        graphCategories = Array.from(new Set(graphCategories));

        // console.log(graphCategories); check if data is available
        let isData = 0;
        this
            .barData
            .forEach((pData, i) => {
                if (pData.data.length < 1) {
                    isData++;
                }
            });
        if (isData != 0 && this.barData.length == isData) {
            this.barData = [];
        }

        if (this.graphData.timeFrame == 'custom') {
            this.xAxis = {
                type: 'datetime',
                // dateTimeLabelFormats: { // don't display the dummy year
                //     month: '%e. %b',
                //     year: '%b'
                // },
                title: {
                    text: this.graphData.timeFrame
                },
                plotLines: this.eventsData
            }
        } else {
            this.xAxis = {
                type: "category",
                categories: graphCategories,
                title: {
                    text: ""
                }
            }
        }

        //set yAxis default label
        let yAxisData: any = [
            {
                title: {
                    text: ""
                }
            }
        ];
        if (this.graphData.udf.axisConfig) {
            if (this.y1AxisAvaialble > 0 && this.y2AxisAvaialble > 0) {
                yAxisData = [
                    {
                        allowDecimals: (this.graphData.udf.axisConfig.y1.decimals && this.graphData.udf.axisConfig.y1.decimals > 0
                            ? true
                            : false),
                        title: {
                            text: (this.graphData.udf.axisConfig.y1.label
                                ? this.graphData.udf.axisConfig.y1.label
                                : "")
                        }
                    }, {
                        allowDecimals: (this.graphData.udf.axisConfig.y2.decimals && this.graphData.udf.axisConfig.y2.decimals > 0
                            ? true
                            : false),
                        title: {
                            text: (this.graphData.udf.axisConfig.y2.label
                                ? this.graphData.udf.axisConfig.y2.label
                                : "")
                        },
                        opposite: true
                    }
                ];
            } else if (this.y1AxisAvaialble == 0 && this.y2AxisAvaialble > 0) {
                yAxisData = [
                    {
                        allowDecimals: (this.graphData.udf.axisConfig.y1.decimals && this.graphData.udf.axisConfig.y1.decimals > 0
                            ? true
                            : false),
                        title: {
                            text: ""
                        }
                    }, {
                        allowDecimals: (this.graphData.udf.axisConfig.y2.decimals && this.graphData.udf.axisConfig.y2.decimals > 0
                            ? true
                            : false),
                        title: {
                            text: (this.graphData.udf.axisConfig.y2.label
                                ? this.graphData.udf.axisConfig.y2.label
                                : "")
                        },
                        opposite: true
                    }
                ];
            } else {
                yAxisData = [
                    {
                        allowDecimals: (this.graphData.udf.axisConfig.y1.decimals && this.graphData.udf.axisConfig.y1.decimals > 0
                            ? true
                            : false),
                        title: {
                            text: (this.graphData.udf.axisConfig.y1.label
                                ? this.graphData.udf.axisConfig.y1.label
                                : "")
                        }
                    }
                ];
            }
        };

        //set default data
        this.options = {
            chart: {
                type: this.graphType,
                zoomType: 'x'
            },
            credits: {
                enabled: false
            },
            title: {
                text: ''
            },
            subtitle: {
                text: document.ontouchstart === undefined ?
                    'Click and drag in the plot area to zoom in' : 'Pinch the chart to zoom in'
            },
            xAxis: this.xAxis,
            // yAxis: [{     title: {         text: 'Values'     },     min: 0 }, { //
            // Primary yAxis     labels: {         format: '{value}°C',         style: {
            //         color: "#ccc"         }     },     title: {         text:
            // 'Temperature',         style: {             color: "#ccc"         }     },
            //  opposite: true }],
            yAxis: yAxisData,
            tooltip: {
                shared: true,
            },

            plotOptions: {
                spline: {
                    marker: {
                        enabled: false
                    },
                    dataLabels: dataLabels
                },
                line: {
                    marker: {
                        enabled: true
                    },
                    dataLabels: dataLabels
                },
                areaspline: {
                    marker: {
                        enabled: false
                    },
                    dataLabels: dataLabels
                },
                series: {
                    turboThreshold: 5000,
                    boostThreshold: 100,
                    dataLabels: dataLabels
                }
            },

            series: this.barData
        };

        // console.log(JSON.stringify(this.options));
    }

}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/components/graphs/spline-chart/spline-chart.component.ts